export default __webpack_public_path__ + "static/media/link_small1.d0297257.svg";